import ActorSelectionScreen from './ActorSelectionScreen';

export default ActorSelectionScreen;
